class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.predictSearchForm = this.querySelector('.search-modal form');
    this.searchButton = this.querySelector('.search-modal .search-btn');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      this.toggleSearchButton(false);
      return;
    }

    this.toggleSearchButton(true);
    this.getSearchResults(searchTerm);
  }

  toggleSearchButton(show) {
    if ( $(window).width() < 767 ) return;

    if ( show  ) {
      $(this.searchButton).show('fade', 300);
    } else {
      $(this.searchButton).hide('fade', 300);
    }
  }

  getSearchResults(searchTerm) {
    let limit = 2;
    if ( $(window).width() > 1200 ) {
      limit = 5;
    } else if (  $(window).width() > 767 ) {
      limit = 4;
    }
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[query]&resources[limit_scope]=each&resources[limit]=${limit}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    // this.predictiveSearchResults.style.display = 'block';
    $(this.predictiveSearchResults).show('fade', 300);
    this.predictSearchForm.classList.add('remove-padding');
  }

  close() {
    // this.predictiveSearchResults.style.display = 'none';
    $(this.predictiveSearchResults).hide('fade', 300);
    this.predictSearchForm.classList.remove('remove-padding');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
